import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export interface ProtectedRouteProps extends RouteProps {
    isAuthenticated: boolean;
    authenticationPath: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = props => {
    if (!props.isAuthenticated) {
      return <Redirect to={{ pathname: props.authenticationPath }} />;
    }
    return <Route {...props} />;
};
